import React, {useState} from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import PublishIcon from "@mui/icons-material/Publish";
import {Button, IconButton, InputAdornment, TextField, TextFieldProps} from "@mui/material";
import {useTranslation} from "react-i18next";

interface FileInputTsProps {
  textFieldProps?: TextFieldProps;
  uploadDisabled?: boolean;
  initialTextValue?: string;
  onUpload?: (file: FileList) => void;
  OnReset?: () => void;
  inputProps?: React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;
}

const FileInputTs = (props: FileInputTsProps) => {
  const [file, setFile] = useState<File | null>(null);
  const {t} = useTranslation();
  const id = props?.inputProps?.id || "file";

  const {onChange, ...otherFileProps} = props.inputProps;

  const resetFileInput = () => {
    setFile(null);
    if (props?.OnReset) {
      props.OnReset();
    } else {
      const inputElement = document.getElementById(id) as HTMLInputElement | null;
      if (inputElement) {
        inputElement.value = "";
      }
    }
  };

  return (
    <>
      <input
        style={{display: "none"}}
        onChange={e => {
          onChange(e);
          setFile(e.currentTarget.files[0]);
          if (props?.onUpload) {
            props.onUpload(e.currentTarget.files);
          }
        }}
        id={id}
        type="file"
        {...otherFileProps}
      ></input>
      <TextField
        value={file?.name || props.initialTextValue || ""}
        variant="outlined"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <label
                htmlFor={id}
                style={{
                  pointerEvents: props.textFieldProps?.disabled ? "none" : "auto"
                }}
              >
                <Button
                  startIcon={<PublishIcon />}
                  variant="outlined"
                  title={t("components.fileInput.upload.title")}
                  component="span"
                  disabled={props.textFieldProps?.disabled}
                >
                  {t("components.fileInput.upload.label")}
                </Button>
              </label>
            </InputAdornment>
          ),
          endAdornment: !!file && (
            <InputAdornment position="end">
              <IconButton
                title={t("components.fileInput.reset.title")}
                onClick={e => resetFileInput()}
                disabled={props.textFieldProps?.disabled}
              >
                <CancelIcon />
              </IconButton>
            </InputAdornment>
          )
        }}
        {...props?.textFieldProps}
      />
    </>
  );
};

export default FileInputTs;
